export default "__VITE_ASSET___sUF1rGC__"